import { render, staticRenderFns } from "./gym.vue?vue&type=template&id=3ed73e84&scoped=true"
import script from "./gym.vue?vue&type=script&lang=js"
export * from "./gym.vue?vue&type=script&lang=js"
import style0 from "./gym.vue?vue&type=style&index=0&id=3ed73e84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed73e84",
  null
  
)

export default component.exports